import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "@/src/store";
import { hydrateAccessFromStorage } from "@/src/store/slices/AccessControl/accessControlSlice";
import { setActualOfficeTable as setApplicationsOffice } from "@/src/store/slices/ApplicationPage/applicationsFiltersSlice";
import { setActualOfficeTable as setTasksOffice } from "@/src/store/slices/TasksPage/tasksFiltersSlice";
import { setActualOfficeTable as setOfficeAccountingOffice } from "@/src/store/slices/OfficeAccountingPage/officeAccountingFiltersSlice";

/**
 * Bootstraps accessControl from localStorage and forces table `office`
 * query params when the user role is locked to one country (point 3).
 */
const AccessControlBootstrap = () => {
  const dispatch = useDispatch<AppDispatch>();
  const hasFullCountryAccess = useSelector((state: RootState) => state.accessControl.hasFullCountryAccess);
  const allowedOffices = useSelector((state: RootState) => state.accessControl.allowedOffices);

  useEffect(() => {
    dispatch(hydrateAccessFromStorage());
  }, [dispatch]);

  useEffect(() => {
    if (hasFullCountryAccess) return;
    const lockedOffice = allowedOffices[0];
    if (!lockedOffice) return;

    dispatch(setApplicationsOffice(lockedOffice));
    dispatch(setTasksOffice(lockedOffice));
    dispatch(setOfficeAccountingOffice(lockedOffice));
  }, [allowedOffices, dispatch, hasFullCountryAccess]);

  return null;
};

export default AccessControlBootstrap;
